/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OverrideJustification } from './OverrideJustification';
import {
  OverrideJustificationFromJSON,
  OverrideJustificationFromJSONTyped,
  OverrideJustificationToJSON,
} from './OverrideJustification';
import type { ResidualRiskLabel } from './ResidualRiskLabel';
import {
  ResidualRiskLabelFromJSON,
  ResidualRiskLabelFromJSONTyped,
  ResidualRiskLabelToJSON,
} from './ResidualRiskLabel';
import type { Risk } from './Risk';
import { RiskFromJSON, RiskFromJSONTyped, RiskToJSON } from './Risk';
import type { RiskProfileDimensionRisk } from './RiskProfileDimensionRisk';
import {
  RiskProfileDimensionRiskFromJSON,
  RiskProfileDimensionRiskFromJSONTyped,
  RiskProfileDimensionRiskToJSON,
} from './RiskProfileDimensionRisk';

/**
 *
 * @export
 * @interface RiskProfileResidualRisk
 */
export interface RiskProfileResidualRisk {
  /**
   *
   * @type {number}
   * @memberof RiskProfileResidualRisk
   */
  readonly id: number;
  /**
   *
   * @type {Risk}
   * @memberof RiskProfileResidualRisk
   */
  readonly risk: Risk;
  /**
   *
   * @type {Array<RiskProfileDimensionRisk>}
   * @memberof RiskProfileResidualRisk
   */
  dimensionRisks: Array<RiskProfileDimensionRisk>;
  /**
   *
   * @type {ResidualRiskLabel}
   * @memberof RiskProfileResidualRisk
   */
  readonly calculatedRiskLabel: ResidualRiskLabel;
  /**
   *
   * @type {ResidualRiskLabel}
   * @memberof RiskProfileResidualRisk
   */
  readonly riskLabel: ResidualRiskLabel;
  /**
   *
   * @type {OverrideJustification}
   * @memberof RiskProfileResidualRisk
   */
  overrideJustification: OverrideJustification;
  /**
   *
   * @type {string}
   * @memberof RiskProfileResidualRisk
   */
  mitigation?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof RiskProfileResidualRisk
   */
  isApplicable?: boolean;
}

/**
 * Check if a given object implements the RiskProfileResidualRisk interface.
 */
export function instanceOfRiskProfileResidualRisk(value: object): value is RiskProfileResidualRisk {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('risk' in value) || value['risk'] === undefined) return false;
  if (!('dimensionRisks' in value) || value['dimensionRisks'] === undefined) return false;
  if (!('calculatedRiskLabel' in value) || value['calculatedRiskLabel'] === undefined) return false;
  if (!('riskLabel' in value) || value['riskLabel'] === undefined) return false;
  if (!('overrideJustification' in value) || value['overrideJustification'] === undefined) return false;
  return true;
}

export function RiskProfileResidualRiskFromJSON(json: any): RiskProfileResidualRisk {
  return RiskProfileResidualRiskFromJSONTyped(json, false);
}

export function RiskProfileResidualRiskFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskProfileResidualRisk {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    risk: RiskFromJSON(json['risk']),
    dimensionRisks: (json['dimension_risks'] as Array<any>).map(RiskProfileDimensionRiskFromJSON),
    calculatedRiskLabel: ResidualRiskLabelFromJSON(json['calculated_risk_label']),
    riskLabel: ResidualRiskLabelFromJSON(json['risk_label']),
    overrideJustification: OverrideJustificationFromJSON(json['override_justification']),
    mitigation: json['mitigation'] == null ? undefined : json['mitigation'],
    isApplicable: json['is_applicable'] == null ? undefined : json['is_applicable'],
  };
}

export function RiskProfileResidualRiskToJSON(
  value?: Omit<RiskProfileResidualRisk, 'id' | 'risk' | 'calculatedRiskLabel' | 'riskLabel'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    dimension_risks: (value['dimensionRisks'] as Array<any>).map(RiskProfileDimensionRiskToJSON),
    override_justification: OverrideJustificationToJSON(value['overrideJustification']),
    mitigation: value['mitigation'],
    is_applicable: value['isApplicable'],
  };
}
